import { render, staticRenderFns } from "./SlipTotals.vue?vue&type=template&id=c7357bd8&scoped=true"
import script from "./SlipTotals.vue?vue&type=script&lang=js"
export * from "./SlipTotals.vue?vue&type=script&lang=js"
import style0 from "./SlipTotals.vue?vue&type=style&index=0&id=c7357bd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7357bd8",
  null
  
)

export default component.exports